class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.onSubmitHandler = this.onSubmitHandler.bind(this);

    const facetForms = this.querySelectorAll('form');
    facetForms.forEach((form) => {
      form.addEventListener('submit', this.onSubmitHandler);

      form.addEventListener('change', (event) => {
        this.updateActiveFacetsPreview(event.target.closest('form'));
      });

      form.addEventListener('input', (event) => {
        if (event.target.matches('input[type="number"], input[name*="price"], input[id*="price"]')) {
          this.updateActiveFacetsPreview(event.target.closest('form'));
        }
      });

      form.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          const tag = event.target.tagName;
          const type = (event.target.type || '').toLowerCase();

          if (tag === 'INPUT' || tag === 'SELECT' || tag === 'TEXTAREA') {
            event.preventDefault();
            form.requestSubmit ? form.requestSubmit() : form.submit();
          } else if (type === 'checkbox' || type === 'radio') {
            event.preventDefault();
            form.requestSubmit ? form.requestSubmit() : form.submit();
          }
        }
      });
    });

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
    /*
    this.updateActiveFacetsPreview(this.querySelector('form'));
    */
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    if (countContainer) countContainer.classList.add('loading');
    if (countContainerDesktop) countContainerDesktop.classList.add('loading');

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const countSource = parsed.getElementById('ProductCount');
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');

    if (countSource && container) {
      container.innerHTML = countSource.innerHTML;
      container.classList.remove('loading');
    }

    if (countSource && containerDesktop) {
      containerDesktop.innerHTML = countSource.innerHTML;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };

    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const target = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
      if (target) target.innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender && event?.target?.closest('.js-filter')) {
      FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      const target = document.querySelector(selector);
      if (!activeFacetsElement || !target) return;
      target.innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      const source = html.querySelector(selector);
      const target = document.querySelector(selector);
      if (!source || !target) return;
      target.innerHTML = source.innerHTML;
    });

    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    if (mobileForm && mobileForm.closest('menu-drawer')) {
      mobileForm.closest('menu-drawer').bindEvents();
    }
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  updateActiveFacetsPreview(form) {
    if (!form) return;

    const containers = document.querySelectorAll('.active-facets-mobile, .active-facets-desktop');
    if (!containers.length) return;

    const checkedInputs = Array.from(
      form.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked')
    );

    const activeItems = [];

    checkedInputs.forEach((input) => {
      const label = form.querySelector(`label[for="${input.id}"]`);
      if (!label) return;

      const filterWrapper = input.closest('.js-filter');
      const summaryLabel = filterWrapper
        ? filterWrapper.querySelector('.facets__summary-label, .facets__summary span')
        : null;

      const filterName = summaryLabel 
      ? summaryLabel.textContent.replace(/\(\d+\)/g, '').trim() 
      : '';
      
      const textLabel = label.querySelector('.facet-checkbox__text-label');
      const valueName = textLabel 
      ? textLabel.textContent.trim() 
      : label.textContent.trim();

      if (valueName) {
        activeItems.push({
          filter: filterName,
          value: valueName
        });
      }
    });

    const priceInputs = Array.from(form.querySelectorAll('input[type="text"]'));
    if (priceInputs.length >= 2) {
      const min = priceInputs[0].value;
      const max = priceInputs[1].value;

      if (min || max) {
        activeItems.push({
          filter: 'Preço',
          value: `${min ? min + '€' : '0€'} - ${max ? max + '€' : '∞'}`
        });
      }
    }

    containers.forEach((container) => {
      const clearAll = container.querySelector('.active-facets__button-wrapper');
      const clearAllHtml = clearAll ? clearAll.outerHTML : '';

      const hasVerticalHeader = !!container.querySelector('.active-facets-vertical-filter');
      const heading = container.querySelector('.facets__heading--vertical');
      const headingHtml = heading ? heading.outerHTML : '';

      const buttonsHtml = activeItems.map((item) => {
        return `
          <span class="active-facets__button active-facets__button--light">
            <span class="active-facets__button-inner button button--tertiary">
              ${item.filter ? `${item.filter}: ` : ''}${item.value}
            </span>
          </span>
        `;
      }).join('');

      if (hasVerticalHeader) {
        container.innerHTML = `
          <div class="active-facets-vertical-filter">
            ${headingHtml}
            ${buttonsHtml}
            ${clearAllHtml}
          </div>
        `;
      } else {
        container.innerHTML = `
          ${buttonsHtml}
          ${clearAllHtml}
        `;
      }
    });
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const submittedForm = event.target.closest('form');
    if (!submittedForm) return;

    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const forms = [];
    const isMobile = submittedForm.id === 'FacetFiltersFormMobile';

    sortFilterForms.forEach((form) => {
      if (!isMobile) {
        if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
          const noJsElements = document.querySelectorAll('.no-js-list');
          noJsElements.forEach((el) => el.remove());
          forms.push(this.createSearchParams(form));
        }
      } else if (form.id === 'FacetFiltersFormMobile') {
        forms.push(this.createSearchParams(form));
      }
    });

    this.onSubmitForm(forms.join('&'), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();